import React, { useContext, useEffect, useState } from "react";
import AppContext from "./hooks/createContext";
import * as _ from "underscore";
import apiClient from "./../../api/client";

const Tool = ({ handleMouseMove }) => {
  const {
    image: [image],
    maskImg: [maskImg, setMaskImg],
  } = useContext(AppContext);

  const imageToBlob = (image) => {
    return new Promise((resolve) => {
      const canvas = document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      const ctx = canvas.getContext("2d");
      if (ctx) {
        ctx.drawImage(image, 0, 0);
        canvas.toBlob((blob) => {
          if (blob) {
            resolve(blob);
          } else {
            throw new Error("Failed to convert image to Blob.");
          }
        });
      } else {
        throw new Error("Failed to get 2D context from canvas.");
      }
    });
  };

  const handleSelect = async () => {
    if (!image || !maskImg) {
      console.error("Error: Image or mask image not provided.");
      return;
    }

    const originalFileBlob = await imageToBlob(image);
    const maskFileBlob = await imageToBlob(maskImg);

    const formData = new FormData();
    formData.append("original_file", originalFileBlob, "original_image.png");
    formData.append("mask_file", maskFileBlob, "mask_image.png");

    try {
      const result = await apiClient.post("mockups/", formData);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const [shouldFitToWidth, setShouldFitToWidth] = useState(true);
  const bodyEl = document.body;

  const fitToPage = () => {
    if (!image) return;
    const imageAspectRatio = image.width / image.height;
    const screenAspectRatio = window.innerWidth / window.innerHeight;
    setShouldFitToWidth(imageAspectRatio > screenAspectRatio);
  };

  const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      if (entry.target === bodyEl) {
        fitToPage();
      }
    }
  });

  useEffect(() => {
    fitToPage();
    resizeObserver.observe(bodyEl);
    return () => {
      resizeObserver.unobserve(bodyEl);
    };
  }, [image]);

  const imageClasses = "";
  const maskImageClasses = `absolute opacity-40 pointer-events-none`;

  return (
    <>
      {image && (
        <img
          onClick={handleMouseMove}
          src={image.src}
          className={`
          ${shouldFitToWidth ? "w-full" : "h-full"} 
          ${imageClasses}`}
        ></img>
      )}
      {maskImg && (
        <img src={maskImg.src} className={`${maskImageClasses}`}></img>
      )}
    </>
  );
};

export default Tool;
